import { Flex, Small, Tag, Icon, Box } from "orcs-design-system";
import React from "react";
import styled from "styled-components";
import themeGet from "@styled-system/theme-get";
import GroupTypeBadgesWrapper from "./components/GroupTypeBadgesWrapper";

const StyledTag = styled(Tag)`
  * {
    cursor: unset !important;
  }
`;

const LegendItem = styled(Flex)`
  color: ${themeGet("colors.greyDarker")};
  align-items: center;
  gap: ${themeGet("space.xs")};
`;

const SPECIAL_TAG_LABEL = "Special tag name";
const TAG_LABEL = "Tag name";
const TAG_TYPE = "TAG TYPE";
const TAGS = "Tags";
const COUNTS = "Counts";

const Legend = () => {
  return (
    <>
      <GroupTypeBadgesWrapper />

      <Small
        fontSize="0"
        fontWeight="600"
        display="block"
        color="greyDark"
        mb="s"
        mt="s"
      >
        <Flex alignItems="center" gap="s">
          <span>#</span>
          {COUNTS}
        </Flex>
      </Small>
      <Box mb="s">
        <Flex flexDirection="column" gap="xs">
          <LegendItem>
            <Icon icon={["fas", "user"]} size="sm" color="greyDarker" />
            <Small fontSize="0">Member count</Small>
          </LegendItem>
          <LegendItem>
            <Icon icon={["fas", "users"]} size="sm" color="greyDarker" />
            <Small fontSize="0">Child team count</Small>
          </LegendItem>
          <LegendItem>
            <Icon icon={["fas", "user-friends"]} size="sm" color="greyDarker" />
            <Small fontSize="0">Direct reports</Small>
          </LegendItem>
          <LegendItem>
            <Small fontSize="0" fontWeight="600">
              FTE
            </Small>
            <Small fontSize="0">Full-time equivalent allocation</Small>
          </LegendItem>
        </Flex>
      </Box>

      <Small
        fontSize="0"
        fontWeight="600"
        display="block"
        color="greyDark"
        mb="s"
        mt="s"
      >
        <Flex alignItems="center" gap="s">
          <Icon icon={["far", "tag"]} color="greyDark" size="sm" />
          {TAGS}
        </Flex>
      </Small>
      <Flex
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap="s"
      >
        <StyledTag small variant="selectedHighlighted" tagType={TAG_TYPE}>
          {SPECIAL_TAG_LABEL}
        </StyledTag>
        <StyledTag small variant="selected" tagType={TAG_TYPE}>
          {TAG_LABEL}
        </StyledTag>
      </Flex>
    </>
  );
};

export default React.memo(Legend);
